import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AppToastContainer.styl";

function AppToastContainer() {
    const AUTO_CLOSE_AFTER_SECONDS = 10;
    const TOASTS_LIMIT = 3;

    return (
        <ToastContainer
            position="bottom-right"
            autoClose={AUTO_CLOSE_AFTER_SECONDS * 1000}
            limit={TOASTS_LIMIT}
            hideProgressBar
            pauseOnFocusLoss
            pauseOnHover
            draggable={false}
            closeOnClick={false}
        />
    );
}

export default AppToastContainer;
